import { Box, Typography } from '@mui/material'
import { ACCENT_COLOR_SWATCHES } from '@/components/Settings/appearanceConstants'
import styles from '@/components/Settings/AppearanceSettingsContent.module.scss'

/**
 * @param {{ value: string, onChange: (value: string) => void }} props
 */
export default function AppearanceColorSwatchRow({ value, onChange }) {
  return (
    <Box className={styles.swatchRow} role="radiogroup" aria-label="Accent colour">
      {ACCENT_COLOR_SWATCHES.map((swatch) => {
        const selected = value === swatch.id
        return (
          <button
            key={swatch.id}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={swatch.label}
            className={styles.swatchOption}
            onClick={() => onChange(swatch.id)}
          >
            <Box
              component="span"
              className={`${styles.swatchCircle}${selected ? ` ${styles.swatchCircleSelected}` : ''}`}
              sx={
                swatch.gradient
                  ? { background: swatch.gradient }
                  : { backgroundColor: swatch.color }
              }
              aria-hidden
            />
            {selected ? (
              <Typography component="span" variant="caption" className={styles.swatchLabel}>
                {swatch.label}
              </Typography>
            ) : null}
          </button>
        )
      })}
    </Box>
  )
}
